
(function inicioControllerDefinition() {

    'use strict';

    angular.module('Inicio')
        .controller('InicioController', [
            'authExtend', '$scope', 'config', '$state', '$translate', '$stateParams', 'loginService', 'errorsExtend', 'login', '$location',
            function inicioController(auth, $scope, config, $state, $translate, $stateParams, loginService, errors, login, $location) {
                $scope.imageStartUrl = ''; 
                $scope.homeTitle = config.homeTitle();
                $scope.homeText = config.homeText();
                $scope.logoSrc = 'app/views/inicio/logo_cpp.png';

                $scope.showForm = false;
                if ($location.search().t) {
                    if (auth.changeApp($location.search().t)) {
                        $scope.showForm = false;
                        if ($location.search().ReturnUrl) {
                            location.href = "/#" +  $location.search().ReturnUrl;
                        }
                    } else {
                        $scope.showForm = true;
                    }
                } else {
                    $scope.showForm = true;
                }


                auth.onIdentityChanged(function identityChangedFn() {

                    $scope.showForm = true;

                    $scope.isLogged = auth.isLogged();

                    $scope.imageStartUrl = auth.getUrlStartImage();
                    
                    if (!$scope.imageStartUrl) {
                        $scope.imageStartUrl = 'app/views/inicio/logo.png';
                    }
                });
                
                $scope.isLogged = auth.isLogged();
                $scope.imageStartUrl = auth.getUrlStartImage();

                if (!$scope.imageStartUrl) {
                    $scope.imageStartUrl = 'app/views/inicio/logo.png';
                }

                $scope.changeUser = function () {
                    if (!$stateParams.key || !auth.isLogged()) {
                        return;
                    }
                    else {
                        loginService.setUser($stateParams.key).then(function (result) {
                            auth.refreshToken().then(function (result) {
                                    if (!result) {
                                        login.logOut();
                                        return;
                                    }
                                },
                          function () {
                              login.logOut();
                          });
                        }, function (error) {
                            errors.showError(error);
                        });
                    }
                };

                $scope.loginResult = function (result) {
                    if (result && auth.getMustChangePassword()) {
                        $state.go('change-password');
                        return false;
                    }

                    return result;
                };

                $scope.changeUser();
            }
        ]);
})();
